import { Image } from 'react-bootstrap';

const Avatar = ({ url }: { url?: string }) => (
  <Image src={url} className="avatar" roundedCircle />
);

export default Avatar;
